import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { EventCard } from "../components/EventCard";
import { Reveal } from "../components/Reveal";
import { JoinTribe } from "../components/Footer";

const Pill = ({ active, children, ...props }) => (
  <button
    {...props}
    className={`px-5 py-2 rounded-full text-xs uppercase tracking-[0.12em] border transition-colors ${
      active ? "bg-terracotta text-cream border-terracotta" : "bg-transparent text-ink border-ink/25 hover:border-terracotta"
    }`}
  >
    {children}
  </button>
);

export const Events = () => {
  const [meta, setMeta] = useState({ cities: [], categories: [] });
  const [events, setEvents] = useState([]);
  const [city, setCity] = useState("All");
  const [category, setCategory] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.meta().then(setMeta).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    api.events({ city, category }).then((d) => { setEvents(d); setLoading(false); }).catch(() => setLoading(false));
  }, [city, category]);

  return (
    <div data-testid="events-page">
      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.2em] text-terracotta mb-5">Experiences near you</p>
          <h1 className="font-serif font-light text-5xl sm:text-6xl md:text-7xl tracking-tighter text-ink leading-none">
            Pick a city. Pick a table.
          </h1>
        </Reveal>
      </section>

      <div data-testid="filter-bar" className="sticky top-16 z-40 bg-cream border-y border-ink/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 space-y-4">
          <div className="flex items-center gap-3 overflow-x-auto pb-1">
            <span className="text-[10px] uppercase tracking-[0.15em] text-muted-earth shrink-0 w-16">City</span>
            <Pill active={city === "All"} onClick={() => setCity("All")} data-testid="city-all">All</Pill>
            {meta.cities.map((c) => (
              <Pill key={c} active={city === c} onClick={() => setCity(c)} data-testid={`city-${c.toLowerCase()}`}>{c}</Pill>
            ))}
          </div>
          <div className="flex items-center gap-3 overflow-x-auto pb-1">
            <span className="text-[10px] uppercase tracking-[0.15em] text-muted-earth shrink-0 w-16">Type</span>
            <Pill active={category === "All"} onClick={() => setCategory("All")} data-testid="category-all">All</Pill>
            {meta.categories.map((c) => (
              <Pill key={c} active={category === c} onClick={() => setCategory(c)} data-testid={`category-${c.toLowerCase().replace(/\s/g, "-")}`}>{c}</Pill>
            ))}
          </div>
        </div>
      </div>

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-14 md:py-20 min-h-[40vh]">
        {loading ? (
          <p className="text-muted-earth">Loading experiences...</p>
        ) : events.length === 0 ? (
          <div data-testid="no-events" className="py-20 text-center">
            <p className="font-serif text-3xl text-ink mb-2">No tables here yet.</p>
            <p className="text-muted-earth">Try another city or category &mdash; we&rsquo;re adding more every week.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6 md:gap-8">
            {events.map((e, i) => (
              <Reveal key={e.id} delay={i * 0.05}><EventCard event={e} /></Reveal>
            ))}
          </div>
        )}
      </section>

      <JoinTribe />
    </div>
  );
};
